import React, { Component } from "react";
import { Table, Button, Col, Row, Tooltip } from "antd";
import axios from "axios";
import PrintModal from '../components/PrintModal';
import moment from "moment-timezone"; // VALIDAR DATAS
import numeral from "numeral";
import "./Relatorios.css";
import Colors from "../utils/Colors";

const { Column } = Table;

class OSPrintModal extends Component {
    state = {
        registro: [],
        os_idf: 0,
        vlr_prod: 0,
        vlr_serv: 0,
        vlr_avul: 0,
        vlr_total: 0,
        listaProdutos: [],
        listaParcelas: [],
        visualizar: false,
        carregando: false,
    }

    componentDidUpdate(propsAnte, stateAnte) {
        // console.log('OSPrintModal - componentDidUpdate - this.props: ', this.props);
        // console.log('OSPrintModal - componentDidUpdate - propsAnte: ', propsAnte);

        if ((this.props.visivel !== propsAnte.visivel) && (this.props.os_idf)) {
            // console.log('OSPrintModal - componentDidUpdate - 2222222');
            this.setState({
                os_idf: this.props.os_idf,
                registro: [],
                visualizar: true,
            });
            this.getListaRegistros();
        }
    }

    getListaRegistros = () => {
        this.setState({ carregando: true, listaRegistros: [] });
        const { os_idf } = this.props;

        axios
            .get(`/ordem_servicos/show/${os_idf}`)
            .then(response => {
                const { data } = response;

                // console.log('getListaRegistros: ', data);

                let listaProdutos = [];
                let vlr_prod = 0;
                let vlr_serv = 0;
                let vlr_avul = 0;
                let vlr_total = 0;

                for (var x in data.listaProdutos) {
                    vlr_prod = vlr_prod + parseFloat(data.listaProdutos[x].mi_vlr_total);

                    listaProdutos.push({
                        ven_idf: 0,
                        venc_idf: 0,
                        mi_idf_condicional: 0,
                        mi_idf: data.listaProdutos[x].mi_idf,
                        mi_item: data.listaProdutos[x].mi_item,
                        mi_servico: { key: '0' },
                        mi_item_Avulso: '',
                        mi_seq: listaProdutos.length + 1,
                        prod_idf: data.listaProdutos[x].prod_idf,
                        pest_qtde: data.listaProdutos[x].pest_qtde,
                        prod_grade: data.listaProdutos[x].prod_grade,
                        mi_item_tamanho: data.listaProdutos[x].mi_item_tamanho,
                        mi_item_cor: data.listaProdutos[x].mi_item_cor,
                        ptam_descricao: data.listaProdutos[x].ptam_descricao,
                        pcor_descricao: data.listaProdutos[x].pcor_descricao,
                        prod_codigo: data.listaProdutos[x].prod_codigo,
                        prod_descricao: data.listaProdutos[x].prod_descricao,
                        prod_cod_barras: data.listaProdutos[x].prod_cod_barras,
                        mi_qtde: parseFloat(data.listaProdutos[x].mi_qtde),
                        mi_vlr_unit: parseFloat(data.listaProdutos[x].mi_vlr_unit),
                        mi_vlr_venda: parseFloat(data.listaProdutos[x].mi_vlr_venda),
                        mi_vlr_venda_min: parseFloat(data.listaProdutos[x].mi_vlr_venda_min),
                        mi_perc_desc: parseFloat(data.listaProdutos[x].mi_perc_desc),
                        mi_vlr_desc: parseFloat(data.listaProdutos[x].mi_vlr_desc),
                        mi_vlr_acres: parseFloat(data.listaProdutos[x].mi_vlr_acres),
                        mi_vlr_total: parseFloat(data.listaProdutos[x].mi_vlr_total),
                        mi_calc_estoque: parseFloat(data.listaProdutos[x].mi_calc_estoque),
                        tipoItem: 'P',
                    });
                };

                for (var x in data.listaServicos) {
                    vlr_serv = vlr_serv + parseFloat(data.listaServicos[x].osis_vlr_total);

                    listaProdutos.push({
                        ven_idf: 0,
                        venc_idf: 0,
                        mi_idf_condicional: 0,
                        mi_item: { key: '0' },
                        mi_servico: data.listaServicos[x].osis_servico,
                        mi_item_Avulso: '',
                        mi_seq: listaProdutos.length + 1,
                        prod_idf: '',
                        pest_qtde: 0,
                        prod_grade: '',
                        mi_item_tamanho: '',
                        mi_item_cor: '',
                        ptam_descricao: '',
                        pcor_descricao: '',
                        prod_codigo: '',
                        prod_descricao: data.listaServicos[x].serv_descricao,
                        prod_cod_barras: '',
                        mi_qtde: parseFloat(data.listaServicos[x].osis_qtde),
                        mi_vlr_unit: parseFloat(data.listaServicos[x].osis_vlr_unit),
                        mi_vlr_venda: parseFloat(data.listaServicos[x].osis_vlr_unit),
                        mi_vlr_venda_min: parseFloat(data.listaServicos[x].osis_vlr_unit),
                        mi_perc_desc: 0,
                        mi_vlr_desc: 0,
                        mi_vlr_acres: 0,
                        mi_vlr_total: parseFloat(data.listaServicos[x].osis_vlr_total),
                        mi_calc_estoque: 0,
                        tipoItem: 'S',
                    });
                };

                for (var x in data.listaAvulsos) {
                    vlr_avul = vlr_avul + parseFloat(data.listaAvulsos[x].osia_vlr_total);

                    listaProdutos.push({
                        ven_idf: 0,
                        venc_idf: 0,
                        mi_idf_condicional: 0,
                        mi_item: { key: '0' },
                        mi_servico: 0,
                        mi_item_Avulso: data.listaAvulsos[x].osia_descricao,
                        mi_seq: listaProdutos.length + 1,
                        prod_idf: '',
                        pest_qtde: 0,
                        prod_grade: '',
                        mi_item_tamanho: '',
                        mi_item_cor: '',
                        ptam_descricao: '',
                        pcor_descricao: '',
                        prod_codigo: '',
                        prod_descricao: data.listaAvulsos[x].osia_descricao,
                        prod_cod_barras: '',
                        mi_qtde: parseFloat(data.listaAvulsos[x].osia_qtde),
                        mi_vlr_unit: parseFloat(data.listaAvulsos[x].osia_vlr_unit),
                        mi_vlr_venda: parseFloat(data.listaAvulsos[x].osia_vlr_unit),
                        mi_vlr_venda_min: parseFloat(data.listaAvulsos[x].osia_vlr_unit),
                        mi_perc_desc: 0,
                        mi_vlr_desc: 0,
                        mi_vlr_acres: 0,
                        mi_vlr_total: parseFloat(data.listaAvulsos[x].osia_vlr_total),
                        mi_calc_estoque: 0,
                        tipoItem: 'A',
                    });
                };

                this.setState({
                    registro: data.dados,
                    listaProdutos: listaProdutos,
                    listaParcelas: data.listaParcelas,
                    vlr_prod,
                    vlr_serv,
                    vlr_avul,
                    vlr_total: vlr_prod + vlr_serv + vlr_avul,
                    carregando: false,
                });
            })
            .catch(erro => {
                console.warn(erro);
                this.setState({
                    carregando: false,
                });
            });
    };

    onCancelar = () => {
        this.setState({
            os_idf: 0,
            registro: [],
            visualizar: false
        })
    }

    onVisualizar = () => {
        this.setState({
            visualizar: true
        })
    }

    renderValor = (ven_vlr_total, registro) => {
        return (
            <span> {numeral(parseFloat(ven_vlr_total)).format('0,000.00')} </span>
        );
    };

    renderTipoItem = (tipo) => {
        return (
            <span> {tipo === 'P' ? 'Produto' : (tipo === 'S' ? 'Serviço' : 'Avulso')} </span>
        );
    };

    renderDescrProduto = (prod_descricao, registro) => {
        return (
            <span> {!registro.prod_grade ? prod_descricao : registro.prod_descricao + ' - ' + registro.ptam_descricao + ' - ' + registro.pcor_descricao} </span>
        );
    };

    renderCheckListSelect = (checkListSelect) => {
        let check = '';
        for (var x in checkListSelect) {
            check = check + checkListSelect[x].clos_descricao + '; ';
        }
        return (
            <span> {check} </span>
        );
    };

    renderData = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY HH:mm')}
                </span>
            )
        } else {
            <span>-</span>
        }
    }

    renderDataParc = (data) => {
        if (data) {
            const dataMoment = moment(data);
            return (
                <span>
                    {dataMoment.format('DD/MM/YYYY')}
                </span>
            )
        } else {
            <span>-</span>
        }
    }




    render() {
        const { onCancelarPrintClick, visivel } = this.props;
        const { carregando, visualizar, listaProdutos, listaParcelas, vlr_avul, vlr_prod, vlr_serv, vlr_total } = this.state;
        const { os_numero, os_data_emissao, pes_codigo, pes_nome, usu_nome,
            cp_descricao, pes_fone1, pes_fone2, pes_fone3,
            pes_endereco, pes_numero, pes_bairro, pes_cep, cmun_descricao, cuf_sigla,
            os_descricao, os_solicitante, oso_defeitos, oso_laudo, checkListSelect } = this.state.registro;

        // console.log('OrdemServicoPrintModal: ', this.state.registro);

        return (
            <span style={{}}>
                {/* <Tooltip title={this.props.hint ? this.props.hint : "Imprimir"}>
                    <Button style={{ height: 25, width: 35, padding: 0 }} onClick={this.onVisualizar} icon="printer" />
                </Tooltip> */}
                <PrintModal
                    visible={visivel}
                    onCancel={onCancelarPrintClick}
                >
                    <div>
                        <Row className="titulo">
                            Ordem de Serviço
                        </Row>

                        <div style={{ marginTop: 10, height: 2, backgroundColor: Colors.background }} />

                        <Row style={{ marginLeft: 20, marginTop: 20, paddingBottom: 10 }}>
                            <Col xs={6} style={{ marginTop: 5 }} >
                                <span style={{ fontWeight: 'bold' }}>Número: </span>
                                <span> {os_numero} </span>
                            </Col>
                            <Col xs={16} style={{ marginTop: 5 }} >
                                <span style={{ fontWeight: 'bold' }}>Data: </span>
                                <span> {this.renderData(os_data_emissao)} </span>
                            </Col>
                            <Col xs={12} style={{ marginTop: 5 }} >
                                <span style={{ fontWeight: 'bold' }}>Vendedor: </span>
                                <span> {usu_nome} </span>
                            </Col>
                            <Col xs={24} style={{ marginTop: 5 }} >
                                <span style={{ fontWeight: 'bold', fontSize: 20 }}>Cliente: </span>
                                <span> {pes_codigo + ' - ' + pes_nome} </span>
                            </Col>
                            {(pes_fone1 !== '' || pes_fone2 !== '' || pes_fone3 !== '') && (pes_fone1 !== '(  )      -' || pes_fone2 !== '(  )      -' || pes_fone3 !== '(  )      -') ? (
                                <Col xs={24} style={{ marginTop: 5 }} >
                                    <span style={{ fontWeight: 'bold' }}>Fones: </span>
                                    <span> {pes_fone1 !== '' && pes_fone1 !== '(  )      -' ? ' - ' + pes_fone1 : ''} </span>
                                    <span> {pes_fone2 !== '' && pes_fone2 !== '(  )      -' ? ' - ' + pes_fone2 : ''} </span>
                                    <span> {pes_fone3 !== '' && pes_fone3 !== '(  )      -' ? ' - ' + pes_fone3 : ''} </span>
                                </Col>
                            ) : null}
                            <Col xs={24} style={{ marginTop: 5, marginBottom: 10 }} >
                                <span style={{ fontWeight: 'bold' }}>Endereço: </span>
                                <span> {pes_endereco ? pes_endereco : ''} </span>
                                <span> {pes_numero ? ' - ' + pes_numero : ''} </span>
                                <span> {pes_bairro ? ' - ' + pes_bairro : ''} </span>
                                <span> {pes_cep ? ' - ' + pes_cep : ''} </span>
                                <span> {cmun_descricao ? ' - ' + cmun_descricao : ''} </span>
                                <span> {cuf_sigla ? ' - ' + cuf_sigla : ''} </span>
                            </Col>
                            <Col xs={12} style={{ marginTop: 5 }} >
                                <span style={{ fontWeight: 'bold' }}>Solicitante: </span>
                                <span> {os_solicitante} </span>
                            </Col>
                            <Col xs={24} style={{ marginTop: 5 }} >
                                <span style={{ fontWeight: 'bold' }}>Descrição: </span>
                                <span> {os_descricao} </span>
                            </Col>
                            {checkListSelect ? (
                                <Col xs={24} style={{ marginTop: 5 }} >
                                    <span style={{ fontWeight: 'bold' }}>CheckList: </span>
                                    <span> {this.renderCheckListSelect(checkListSelect)} </span>
                                </Col>
                            ) : null}
                            {oso_defeitos ? (
                                <Col xs={24} style={{ marginTop: 5 }} >
                                    <span style={{ fontWeight: 'bold' }}>Defeitos Relatados: </span>
                                    <span> {oso_defeitos} </span>
                                </Col>
                            ) : null}
                            {oso_laudo ? (
                                <Col xs={24} style={{ marginTop: 5 }} >
                                    <span style={{ fontWeight: 'bold' }}>Laudo Técnico: </span>
                                    <span> {oso_laudo} </span>
                                </Col>
                            ) : null}
                        </Row>

                        <Row style={{ marginTop: 10 }}>
                            <Col xs={6} style={{ marginTop: 5, textAlign: "end" }} >
                                <span style={{ fontSize: 14, fontWeight: 'bold' }}>Produtos: </span>
                                <span style={{ fontSize: 15 }}> R$ {this.renderValor(vlr_prod)} </span>
                            </Col>
                            <Col xs={6} style={{ marginTop: 5, textAlign: "end" }} >
                                <span style={{ fontSize: 14, fontWeight: 'bold' }}>Serviços: </span>
                                <span style={{ fontSize: 15 }}> R$ {this.renderValor(vlr_serv)} </span>
                            </Col>
                            <Col xs={6} style={{ marginTop: 5, textAlign: "end" }} >
                                <span style={{ fontSize: 14, fontWeight: 'bold' }}>Avulsos: </span>
                                <span style={{ fontSize: 15 }}> R$ {this.renderValor(vlr_avul)} </span>
                            </Col>
                            <Col xs={6} style={{ marginTop: 5, textAlign: "end" }} >
                                <span style={{ fontSize: 14, fontWeight: 'bold' }}>Total O.S: </span>
                                <span style={{ fontSize: 15 }}> R$ {this.renderValor(vlr_total)} </span>
                            </Col>
                        </Row>

                        <Row style={{ marginBottom: 20 }}>
                            <div style={{ color: Colors.textDisabledDark, fontSize: 16, fontWeight: "bold", paddingLeft: 20, paddingTop: 3, marginTop: 10, marginBottom: 10, height: 30, backgroundColor: Colors.background }}>
                                ITENS DA O.S
                            </div>

                            <Row>
                                <Table
                                    pagination={false}
                                    dataSource={listaProdutos}
                                    // className="tabela"
                                    rowKey={(listaRegistros => listaRegistros.mi_idf)}
                                    loading={{
                                        spinning: carregando,
                                        tip: 'Carregando. Aguarde...',
                                        size: "large"
                                    }}
                                >
                                    <Column
                                        key="tipoItem"
                                        dataIndex="tipoItem"
                                        title="Tipo Item"
                                        width={60}
                                        align="center"
                                        className="listaCadastro"
                                        render={this.renderTipoItem}
                                    />
                                    <Column
                                        key="prod_codigo"
                                        dataIndex="prod_codigo"
                                        title="Código"
                                        width={60}
                                        align="center"
                                        className="listaCadastro"
                                    />
                                    <Column
                                        key="prod_descricao"
                                        dataIndex="prod_descricao"
                                        title="Descrição"
                                        width={200}
                                        align="left"
                                        className="listaCadastro"
                                        render={this.renderDescrProduto}
                                    />
                                    <Column
                                        key="mi_qtde"
                                        dataIndex="mi_qtde"
                                        title="Qtde"
                                        render={this.renderValor}
                                        width={60}
                                        align="right"
                                        className="listaCadastro"
                                    />
                                    <Column
                                        key="mi_vlr_unit"
                                        dataIndex="mi_vlr_unit"
                                        title="Vlr Unit"
                                        render={this.renderValor}
                                        width={60}
                                        align="right"
                                        className="listaCadastro"
                                    />
                                    <Column
                                        key="mi_vlr_desc"
                                        dataIndex="mi_vlr_desc"
                                        title="Vlr Desc"
                                        render={this.renderValor}
                                        width={60}
                                        align="right"
                                        className="listaCadastro"
                                    />
                                    <Column
                                        key="mi_vlr_total"
                                        dataIndex="mi_vlr_total"
                                        title="Vlr Total"
                                        render={this.renderValor}
                                        width={60}
                                        align="right"
                                        className="listaCadastro"
                                    />
                                </Table>
                            </Row>
                        </Row>

                        {listaParcelas && listaParcelas.length > 0 ? (
                            <Row style={{ marginTop: 10, marginBottom: 20 }}>
                                <div style={{ color: Colors.textDisabledDark, fontSize: 16, fontWeight: "bold", paddingLeft: 20, paddingTop: 3, marginTop: 10, marginBottom: 10, height: 30, backgroundColor: Colors.background }}>
                                    FORMA DE PAGAMENTO - {this.state.listaParcelas[0].cp_descricao}
                                </div>
                                <Row>
                                    <Table
                                        dataSource={listaParcelas}
                                        pagination={false}
                                        rowKey={(listaParcelas => listaParcelas.tparc_parcela)}
                                        loading={{
                                            spinning: carregando,
                                            tip: 'Carregando. Aguarde...',
                                            size: "large"
                                        }}
                                    >
                                        <Column
                                            key="tparc_parcela"
                                            dataIndex="tparc_parcela"
                                            title="Parcela"
                                            width={60}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="tparc_data_parcela"
                                            dataIndex="tparc_data_parcela"
                                            title="Data Venc"
                                            width={80}
                                            align="center"
                                            className="listaCadastro"
                                            render={this.renderDataParc}
                                        />
                                        <Column
                                            key="tparc_valor"
                                            dataIndex="tparc_valor"
                                            title="Valor Parc"
                                            render={this.renderValor}
                                            width={80}
                                            align="right"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="situacao_parcela"
                                            dataIndex="situacao_parcela"
                                            title="Situação"
                                            width={80}
                                            align="center"
                                            className="listaCadastro"
                                        />
                                        <Column
                                            key="td_descricao"
                                            dataIndex="td_descricao"
                                            title="Tipo Documento"
                                            width={300}
                                            align="left"
                                            className="listaCadastro"
                                        />
                                    </Table>
                                </Row>
                            </Row>
                        ) : null}

                    </div>

                </PrintModal>
            </span>
        );
    }
}

export default OSPrintModal;



// WEBPACK FOOTER //
// ./src/relatorios/OSPrintModal.js